/**
 * Public store URLs for marketing CTAs.
 * ASC app id matches `submit.*.ios.ascAppId` in mobile/eas.json.
 */
export const IOS_APP_STORE_URL = "https://apps.apple.com/app/id6783357524";
